/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import Payments from 'payment'
import { constants as L100Constants } from '../../constants';

import * as actionCreators from '../../root/actions'
import TextInput from '../../components/TextInput'

import style from './style'
import 'react-credit-cards/es/styles-compiled.css'

import { VISIT_URL } from '../../api/endpoints'

export class Payment extends Component {
  state = {
    number: '',
    name: '',
    expiry: '',
    cvc: '',
    focused: '',
    isSubmitting: false
  }

  render() {
    const { classes } = this.props

    return (
      <div className={classes.base}>
        <form className="payment-container" onSubmit={this.onSubmit}>
          <div>Please enter your payment details below.</div>
          <TextInput
            type="tel"
            name="number"
            className="underlineText"
            placeholder="Card Number"
            required
            onKeyUp={this.onChange}
            onFocus={this.onFocus}
            autoComplete="cc-number"
          />

          <TextInput
            type="text"
            name="name"
            className="underlineText"
            placeholder="Name on Card"
            required
            onKeyUp={this.onChange}
            onFocus={this.onFocus}
            autoComplete="cc-name"
          />

          <div className="flexRowSpaceBetween">
            <TextInput
              type="text"
              name="expiry"
              className="underlineText ccExpiry"
              placeholder="Exp (MM/YY)"
              required
              onKeyUp={this.onChange}
              onFocus={this.onFocus}
              autoComplete="cc-exp"
            />
            <TextInput
              type="text"
              name="cvc"
              className="underlineText ccCVC"
              placeholder="CVC"
              required
              onKeyUp={this.onChange}
              onFocus={this.onFocus}
              autoComplete="cc-csc"
            />
          </div>
        </form>
      </div>
    )
  }

  onChange = e => {
    const { target } = e

    if (target.name === 'number') {
      this.setState({
        [target.name]: target.value.replace(/ /g, '')
      })
    } else if (target.name === 'expiry') {
      this.setState({
        [target.name]: target.value.replace(/\//g, '')
      })
    } else {
      this.setState({
        [target.name]: target.value
      })
    }
    this.validateForm()
  }

  onFocus = e => {
    const { target } = e
    this.setState({
      focused: target.name
    })
  }

  validateForm() {
    const { validatePayment, setPaymentData } = this.props

    const number = document
      .querySelector('.payment-container [name="number"]')
      .value.replace(/\s/g, '')

    const expiration = document
      .querySelector('.payment-container [name="expiry"]')
      .value.replace(/\s/g, '')

    const code = document
      .querySelector('.payment-container [name="cvc"]')
      .value.replace(/\s/g, '')

    const validCC = Payments.fns.validateCardNumber(number)
    const validExpiry = Payments.fns.validateCardExpiry(expiration)
    const validCVC = Payments.fns.validateCardCVC(code)

    if (!validCC || !validExpiry || !validCVC) {
      validatePayment(false)
      return false
    } else {
      const paymentData = {
        number,
        expiration,
        code
      }
      setPaymentData(paymentData)
      validatePayment(true)
    }
  }

  onSubmit = e => {
    e.preventDefault()
    if (this.state.isSubmitting) return
    this.setState({ isSubmitting: true })
    const { apiRequest, containers, changeRoute } = this.props
    const { number, expiry, cvc } = this.state
    const { schedule } = containers
    const date = schedule.get('selectedTimeslot').time

    const paymentData = {
      number,
      expiration: expiry,
      code: cvc
    }

    const data = {
      paymentData: {
        number: String(L100Constants.notSet),
        expiration: String(L100Constants.notSet),
        code: String(L100Constants.notSet)
      },
      date
    }

    if (paymentData) data.paymentData = paymentData

    const request = {
      url: VISIT_URL,
      method: 'post',
      data
    }

    const meta = {
      onError: () => {
        this.setState({ isSubmitting: false }, () =>
          changeRoute({ route: '/upcoming/schedule' })
        )
      },
      onSuccess: () => {
        this.setState({ isSubmitting: false }, () =>
          changeRoute({ route: '/' })
        )
      }
    }

    apiRequest(request, meta)
  }

  UNSAFE_componentWillMount() {
    const { changeRoute, containers } = this.props
    const { schedule } = containers

    if (schedule.get('selectedTimeslot') === null) changeRoute({ route: '/' })
  }

  componentDidMount() {
    Payments.formatCardNumber(
      document.querySelector('.payment-container [name="number"]')
    )
    Payments.formatCardExpiry(
      document.querySelector('.payment-container [name="expiry"]')
    )
    Payments.formatCardCVC(
      document.querySelector('.payment-container [name="cvc"]')
    )
  }
}

const mapStateToProps = state => {
  const { containers, api } = state

  return {
    containers,
    api
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(actionCreators, dispatch)
}

export default injectSheet(() => style)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Payment)
)
